import { render, staticRenderFns } from "./PreloaderOnCreation.vue?vue&type=template&id=13a84c44&scoped=true&"
var script = {}
import style0 from "./PreloaderOnCreation.vue?vue&type=style&index=0&id=13a84c44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a84c44",
  null
  
)

export default component.exports